import { SeasonTrades } from "../../schemas/Trade";
import { manager } from "../stringConstants";

export const itayTrades: SeasonTrades[] = [
  {
    season: "2009/10",
    allTrades: [
      {
        otherTeam: manager.mati,
        sentAway: "Andrea Bargnani",
        gotInReturn: "David West, Allen Iverson",
      },
    ],
  },
  {
    season: "2011/12",
    allTrades: [
      {
        otherTeam: manager.yevgeny,
        sentAway: "Andrew Bynum",
        gotInReturn: "Kyrie Irving and Emeka Okafor",
      },
    ],
  },
  {
    season: "2012/13",
    allTrades: [
      {
        otherTeam: manager.nissim,
        sentAway: "Dwyane Wade and Luol Deng",
        gotInReturn: "Dirk Nowitki and David Lee",
      },
      {
        otherTeam: manager.oded,
        sentAway: "Kyrie Irving and Patrick Patterson",
        gotInReturn: "Stephen Curry and Carmelo Anthony",
      },
      {
        otherTeam: manager.chauncey,
        sentAway: "Stephen Curry and Devin Harris",
        gotInReturn: "Monta Ellis and Anderson Varejao",
        amongWorstTrades: true
      },
    ],
  },

  {
    season: "2013/14",
    allTrades: [
      {
        otherTeam: manager.dom,
        sentAway: "Michael Carter-Williams and Jameer Nelson",
        gotInReturn: "Serge Ibaka and Brandon Jennings",
      },
      {
        otherTeam: manager.chauncey,
        sentAway: "Carlos Boozer",
        gotInReturn: "Kobe Bryant",
      },
      {
        otherTeam: manager.chauncey,
        sentAway: "Andrew Bogut",
        gotInReturn: "Kyle Korver",
      },
    ],
  },

  {
    season: "2014/15",
    allTrades: [
      {
        otherTeam: manager.yevgeny,
        sentAway: "Thaddeus Young",
        gotInReturn: "Chris Bosh",
      },
      {
        otherTeam: manager.chauncey,
        sentAway: "Andrew Bogut",
        gotInReturn: "Kevin Martin",
      },
      {
        otherTeam: manager.chauncey,
        sentAway: "Serge Ibaka",
        gotInReturn: "Andrew Bogut, Ty Lawson and KJ McDaniels",
      },
    ],
  },

  {
    season: "2015/16",
    allTrades: [
      {
        otherTeam: manager.dom,
        sentAway: "Pau Gasol and Mirza Teletovic",
        gotInReturn: "Ish Smith and Jerami Grant",
      },
      {
        otherTeam: manager.idan,
        sentAway: "Al Horford",
        gotInReturn: "Trevor Ariza and Jeff Teague",
      },
    ],
  },
  {
    season: "2016/17",
    allTrades: [
      {
        otherTeam: manager.zeev,
        sentAway: "Kevin Love",
        gotInReturn: "Ben Simmons",
      },
      {
        otherTeam: manager.yevgeny,
        sentAway: "Pau Gasol",
        gotInReturn: "Emmanuel Mudiay",
      },
      {
        otherTeam: manager.mati,
        sentAway: "Jeremy Lin",
        gotInReturn: "D'Angelo Russell",
      },
      {
        otherTeam: manager.mati,
        sentAway: "Jusuf Nurkic and Jeremy Lin",
        gotInReturn: "Robert Covington and Jeff Teague",
      },
      {
        otherTeam: manager.zeev,
        sentAway: "Kemba Walker",
        gotInReturn: "Kevin Love",
      },
    ],
  },
  {
    season: "2017/18",
    allTrades: [
      {
        otherTeam: manager.yevgeny,
        sentAway: "Enes Kanter and Tobias Harris",
        gotInReturn: "Marc Gasol",
      },
      {
        otherTeam: manager.yevgeny,
        sentAway: "Elfrid Payton",
        gotInReturn: "Carmelo Anthony",
      },
      {
        otherTeam: manager.mati,
        sentAway: "Nikola Mirotic",
        gotInReturn: "JJ Redick and Michael Beasley",
      },
    ],
  },
  {
    season: "2018/19",
    allTrades: [
      {
        otherTeam: manager.yevgeny,
        sentAway: "Trae Young, Kevin Love and Harrison Barnes",
        gotInReturn: "Tobias Harris, Khris Middleton and JJ Redick",
      },
      {
        otherTeam: manager.nissim,
        sentAway: "DeAndre Jordan",
        gotInReturn: "CJ McCollum",
      },
      {
        otherTeam: manager.mati,
        sentAway: "Anthony Davis, Julius Randle and Andrew Wiggins",
        gotInReturn: "Joel Embiid, Myles Turner, Jarrett Allen and Kyle Lowry",
        amongBestTrades: true,
      },
    ],
  },
  { season: "2019/20", allTrades: [] },
  { season: "2020/21", allTrades: [] },
  {
    season: "2021/22",
    allTrades: [
      {
        otherTeam: manager.mati,
        sentAway: "Harrison Barnes",
        gotInReturn: "Montrezl Harrell",
      },
    ],
  },
  {
    season: "2022/23",
    allTrades: [
      {
        otherTeam: manager.idan,
        sentAway: "3rd round pick (#23)",
        gotInReturn: "Bradley Beal and 4th round pick"
      },
      {
        otherTeam: manager.mati,
        sentAway: "Kevin Huerter",
        gotInReturn: "Chris Paul"
      },
      {
        otherTeam: manager.mati,
        sentAway: "Klay Thompson",
        gotInReturn: "LeBron James"
      }
    ],
  },
  { season: "2023/24", allTrades: [] },
  { season: "2024/25", allTrades: [] }
];
